/**
 * Recursively omits specified keys from an object.
 * Replacement for omit-deep-lodash to avoid pulling in CJS lodash.
 */
const omitDeep = <T>(value: T, keys: string[]): T => {
  if (Array.isArray(value)) {
    return value.map((item) => omitDeep(item, keys)) as T;
  }

  if (value !== null && typeof value === 'object') {
    const result: Record<string, unknown> = {};

    for (const [key, val] of Object.entries(value)) {
      if (!keys.includes(key)) {
        result[key] = omitDeep(val, keys);
      }
    }

    return result as T;
  }

  return value;
};

export default omitDeep;
